module.exports = __webpack_public_path__ + "img/theodore-alexander-mob-compressed.9bd5d9a.png";